import { RemoveFeaturesCommand } from './remove-features-command';

export class CreateFeaturesCommand extends RemoveFeaturesCommand {

  redo () { super.undo(); }

  undo () { super.redo(); }

}
